<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import AppShell from '@/components/AppShell.vue';
import ToastContainer from '@/components/ToastContainer.vue';
import { useMeStore } from '@/stores/me';

const route = useRoute();
const me = useMeStore();

// /login renders chrome-less; everything else gets the AppShell.
const isPublic = computed(() => route.meta.public === true);
</script>

<template>
    <div v-if="!me.loaded" class="flex h-full items-center justify-center text-sm text-slate-500">
        {{ $t('common.state.loading') }}
    </div>

    <RouterView v-else-if="isPublic" />

    <AppShell v-else>
        <RouterView />
    </AppShell>

    <!-- Mounted once globally. `toast.success()` etc. anywhere in the app
         push into a shared queue; this renders + dismisses. -->
    <ToastContainer />
</template>
